import type { PiralPlugin } from 'piral-core';

const plugins: Array<PiralPlugin> = [];

export default plugins;
